export interface BankBrand {
  from: string;
  to: string;
  textOnBrand: 'light' | 'dark';
}

const BRANDS: Array<{ match: string[]; brand: BankBrand }> = [
  { match: ['itau', 'itaú'], brand: { from: '#EC7000', to: '#F39200', textOnBrand: 'light' } },
  { match: ['nubank', 'nu pagamentos'], brand: { from: '#820AD1', to: '#A663EE', textOnBrand: 'light' } },
  { match: ['bradesco'], brand: { from: '#CC092F', to: '#E83A56', textOnBrand: 'light' } },
  { match: ['santander'], brand: { from: '#EC0000', to: '#FF5050', textOnBrand: 'light' } },
  { match: ['banco do brasil', 'bb '], brand: { from: '#F9D71C', to: '#FFE94D', textOnBrand: 'dark' } },
  { match: ['caixa'], brand: { from: '#005CA9', to: '#0078D4', textOnBrand: 'light' } },
  { match: ['inter'], brand: { from: '#FF7A00', to: '#FF9A3C', textOnBrand: 'light' } },
  { match: ['c6 '], brand: { from: '#111111', to: '#3A3A3A', textOnBrand: 'light' } },
  { match: ['picpay'], brand: { from: '#11C76F', to: '#1FE082', textOnBrand: 'light' } },
  { match: ['btg'], brand: { from: '#001E50', to: '#002F7D', textOnBrand: 'light' } },
  { match: ['mercado pago', 'mercadopago'], brand: { from: '#00BCD4', to: '#26D6E8', textOnBrand: 'light' } },
  { match: ['will'], brand: { from: '#FFD500', to: '#FFE94D', textOnBrand: 'dark' } },
  { match: ['next'], brand: { from: '#00FF5F', to: '#00D14F', textOnBrand: 'dark' } },
  { match: ['neon'], brand: { from: '#00C2FF', to: '#33D6FF', textOnBrand: 'light' } },
  { match: ['original'], brand: { from: '#00B248', to: '#26C76F', textOnBrand: 'light' } },
  { match: ['safra'], brand: { from: '#0B3D91', to: '#1456B5', textOnBrand: 'light' } },
  { match: ['xp '], brand: { from: '#000000', to: '#2C2C2C', textOnBrand: 'light' } },
  { match: ['rico'], brand: { from: '#FFDE00', to: '#FFE94D', textOnBrand: 'dark' } },
  { match: ['clear'], brand: { from: '#FFB400', to: '#FFC93C', textOnBrand: 'dark' } },
  { match: ['banrisul'], brand: { from: '#0066B3', to: '#1A85D6', textOnBrand: 'light' } },
  { match: ['sicredi'], brand: { from: '#3DA935', to: '#5BC753', textOnBrand: 'light' } },
  { match: ['sicoob'], brand: { from: '#003641', to: '#0A5566', textOnBrand: 'light' } },
];

const FALLBACK: BankBrand = { from: '#0F766E', to: '#10B981', textOnBrand: 'light' };

export function getBankBrand(connectorName: string | undefined | null): BankBrand {
  if (!connectorName) return FALLBACK;
  const key = connectorName.toLowerCase();
  for (const entry of BRANDS) {
    if (entry.match.some((m) => key.includes(m))) return entry.brand;
  }
  return FALLBACK;
}
